import { Card, Label } from "./DataCard";
import { markAsRead } from "../../services/MessageService";
import { useState } from "react";
import { useTheme } from "styled-components";

function MessageCard({ message, onRead }) {
    const [read, setRead] = useState(message.isRead);
    const theme = useTheme();

    async function handleMarkAsRead() {
        if (!read) {
            try {
                await markAsRead(message.id);
                setRead(true);
                if (onRead) {
                    onRead(message.id);
                }
            } catch (err) {
                console.error("Greška prilikom označavanja poruke:", err);
            }
        }
    }

    return (
        <Card
            onClick={handleMarkAsRead}
            onMouseEnter={handleMarkAsRead}
            style={{
                backgroundColor: read ? theme.colors.background : theme.colors.card,
                cursor: "pointer"
            }}
        >
            <Label>
                {message.content}
            </Label>
        </Card>
    );
}

export default MessageCard;
